// extracted by mini-css-extract-plugin
export default {"col_1000":"index_col_1000_5QvJW","col_640":"index_col_640_cNgB4","col_300":"index_col_300_lhAfC","col_455_l":"index_col_455_l_lvrk2","col_455_r":"index_col_455_r_tz1JW"};